export default __webpack_public_path__ + "static/media/4.e0174369.jpg";